import { ReactComponent as IconInfo } from "../assets/icons/icons-info.svg";
import { APPOINTMENT_TYPES } from "./AppointmentTypeIcon/AppointmentTypeIcon";

export default function AppointmentTypeText({
  appointmentType,
  shuttleServiceSelected,
  onAfterHoursClick,
}) {
  const config = APPOINTMENT_TYPES[appointmentType];

  if (!config || appointmentType === "dropoff") {
    return (
      <div>
        {shuttleServiceSelected ? "Dropoff + Shuttle: " : "Dropoff: "}
        <small>
          Please note we will begin service at our first available opportunity
          after dropoff.
        </small>
      </div>
    );
  }

  if (appointmentType === "ahdo") {
    return (
      <p className="after-hours-label">
        After Hours Drop Off
        <button className="dropoff-info-button" onClick={onAfterHoursClick}>
          <IconInfo />
        </button>
      </p>
    );
  }

  if (config) {
    return <div>{config.label}</div>;
  }

  return null;
}
